export * from './filters.component';
export * from './price-filter/price-filter.component';
export * from './stops-filter/stops-filter.component';
export * from './departure-time-filter/departure-time-filter.component';
export * from './arrival-time-filter/arrival-time-filter.component';
export * from './airlines-filter/airlines-filter.component';
export * from './stopover-city-filter/stopover-city-filter.component';
export * from './airports-nearby-filter/airports-nearby-filter.component';
export * from '../sorting/sorting.component';
export * from './preferences-filter/preferences-filter.component';

// export {
//     SortingComponent,
//     FiltersComponent,
//     PriceFilterComponent,
//     StopsFilterComponent,
//     DepartureTimeFilterComponent,
//     ArrivalTimeFilterComponent,
//     AirlinesFilterComponent,
//     AirportsNearbyFilterComponent,
//     StopoverCityFilterComponent,
//     PreferencesFilterComponent,
// }